import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { MedicalRecordsPdfInput } from './medical-records.models';
import { MedicalRecordsPdfService } from './medical-records.service';

@Component({
  selector: 'lib-medical-records',
  standalone: true,
  templateUrl: './medical-records.component.html',
  styleUrl: './medical-records.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MedicalRecordsPdfService],
})
export class MedicalRecordsComponent {
  private readonly pdfService = inject(MedicalRecordsPdfService);

  readonly pdfData = input.required<MedicalRecordsPdfInput>();
  readonly generationError = output<unknown>();

  generatePdfDocument(): void {
    try {
      this.pdfService.download(this.pdfData());
    } catch (error: unknown) {
      this.generationError.emit(error);
    }
  }
}
